import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, switchMap, timeout } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly publicRoutes: Array<RegExp> = [
    new RegExp('/auth/.+$'),
    new RegExp('/support/contact$'),
  ];

  private accessTokenDeferTimeout = 15000;

  constructor(private authService: AuthService) {}

  /**
   * Hold any requests to protected routes until fresh access token is available, failing if the token isn't
   * available before the timeout window
   */
  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!this.isProtectedRoute(request.url)) {
      return next.handle(request);
    } else {
      return this.authService.accessToken$.pipe(
        first(),
        timeout(this.accessTokenDeferTimeout),
        switchMap((token) => {
          return next.handle(this.addToken(request, token));
        }),
      );
    }
  }

  private addToken(
    request: HttpRequest<unknown>,
    token: string,
  ): HttpRequest<unknown> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  private isProtectedRoute(route: string): boolean {
    if (route.startsWith(environment.api)) {
      return !this.publicRoutes.some((publicRoute) => publicRoute.test(route));
    }

    return false;
  }
}
